
define('inlineSvg!svgs/icon/plus', function () {return '<span class="inline-plus inline-icon"><svg width="18" height="18" viewBox="0 0 18 18"><path d="M8.2 0h1.6l.4 7.8 7.8.4v1.6l-7.8.4-.4 7.8H8.2l-.4-7.8L0 9.8V8.2l7.8-.4.4-7.8z"/></svg></span>';});

